import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { formSubmitEntrypoint } from '@atlassian/jira-spa-apps-business-form-submit/entrypoint.tsx';

export const formSubmitPageEntrypoint = createPageEntryPoint({
	main: formSubmitEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
